// App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/MainLayout';
import Login from './components/Login';
import RecipeList from './components/Recetas/index';
import RecipeEdit from './components/Recetas/Edit';
import RecipeNew from './components/Recetas/New';
import IngredientList from './components/Ingredientes/index';
import IngredientEdit from './components/Ingredientes/Edit';
import IngredientNew from './components/Ingredientes/New';
import BannerList from './components/Banners/index';
import BannerNew from './components/Banners/New';
import TipList from './components/Tips/index';
import TipNew from './components/Tips/New';
import TipEdit from './components/Tips/Edit';
import TiempoDiaList from './components/TiempoDia/index';
import TiempoDiaNew from './components/TiempoDia/New';
import Dashboard from './components/Dashboard/index';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';

function App() {
  return (
    
      <AuthProvider>
        <Routes>
          {/* Rutas públicas */}
          <Route path="/login" element={<Login />} />

          {/* Rutas privadas dentro de MainLayout */}
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <MainLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="recetas" element={<RecipeList />} />
            <Route path="recetas/new" element={<RecipeNew />} />
            <Route path="recetas/edit/:id" element={<RecipeEdit />} />
            <Route path="ingredientes" element={<IngredientList />} />
            <Route path="ingredientes/new" element={<IngredientNew />} />
            <Route path="ingredientes/edit/:id" element={<IngredientEdit />} />
            <Route path="banners" element={<BannerList />} />
            <Route path="banners/new" element={<BannerNew />} />
            <Route path="tips" element={<TipList />} />
            <Route path="tips/new" element={<TipNew />} />
            <Route path="tips/edit/:id" element={<TipEdit />} />
            <Route path="tiempodia" element={<TiempoDiaList />} />
            <Route path="tiempodia/new" element={<TiempoDiaNew />} />
          </Route>

          {/* Cualquier otra ruta redirige al login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    
  );
}

export default App;
